import { MoreVert } from "@mui/icons-material";
import { IconButton, Link, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import { AnyAction, bindActionCreators, Dispatch } from "redux";
import { UrlPathPreferences } from "../../api/url";
import { canMaintainPreferences } from "../../store/actions/LoginActions";
import { thunkDeleteQuestion } from "../../store/actions/PreferenceActions";
import { IStore } from "../../store/IStore";
import { QuestionDto } from "../../store/models/preferences/QuestionDto";
import { useTranslation } from "react-i18next";
import KnistrConfirmDialog from "../atoms/KnistrConfirmDialog";

interface PreferencesTableMenuProps {
  question: QuestionDto;
}

const PreferencesTableMenu = (props: PreferencesTableMenuProps & ThunkProps) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement>();
  const [confirmVisible, setConfirmVisible] = useState<boolean>();
  if (!canMaintainPreferences()) return null;
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(undefined);
  };

  return (
    <div>
      {confirmVisible && (
        <KnistrConfirmDialog
          title={t("preferences.confirmDialogTitle")}
          description={t("preferences.confirmDialogDescription")}
          cancelButton={t("common.cancel")}
          confirmButton={t("common.delete")}
          onConfirm={() => props.thunkDeleteQuestion(props.question)}
          setConfirmVisible={setConfirmVisible}
        />
      )}
      <IconButton onClick={handleClick}>
        <MoreVert />
      </IconButton>
      <Menu id="long-menu" anchorEl={anchorEl} keepMounted open={open} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            setConfirmVisible(true);
            handleClose();
          }}
        >
          {t("preferences.kebabMenuDelete")}
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <Link component={RouterLink} to={`${UrlPathPreferences}/${props.question.questionNumber}/edit`}>
            {t("preferences.kebabMenuEdit")}
          </Link>
        </MenuItem>
      </Menu>
    </div>
  );
};

const mapStateToProps = (_state: IStore) => ({});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => bindActionCreators({ thunkDeleteQuestion }, dispatch);

const connector = connect(mapStateToProps, mapDispatchToProps);
type ThunkProps = ConnectedProps<typeof connector>;
export default connector(PreferencesTableMenu);
